import * as React from 'react';
import { Box } from 'rebass';
import { theme } from './theme';

interface CSSHideProps {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  children: React.ReactNode;
}

// calc() is not fully supported in ie11 so for now I had to hard code the max values
export const cssBreakpoints: any = [
  ['xs', `@media screen and (max-width: 479px)`],
  [
    'sm',
    `@media screen and (min-width: ${theme.breakpoints[0]}) and (max-width: 767px)`,
  ],
  [
    'md',
    `@media screen and (min-width: ${theme.breakpoints[1]}) and (max-width: 1023px)`,
  ],
  [
    'lg',
    `@media screen and (min-width: ${theme.breakpoints[2]}) and (max-width: 1279px)`,
  ],
  ['xl', `@media screen and (min-width: ${theme.breakpoints[5]})`],
];

const sxProp = (sizes: Omit<CSSHideProps, 'children'>) =>
  cssBreakpoints.reduce(
    (
      sx: { [key: string]: { [key: string]: any } },
      [sizeName, cssSelector]: [keyof Omit<CSSHideProps, 'children'>, string]
    ) => {
      if (!!sizes[sizeName]) {
        sx[cssSelector] = {
          display: 'none',
        };
      }
      return sx;
    },
    {}
  );

export const CSSHide = ({ children, ...sizes }: CSSHideProps) => (
  <Box sx={sxProp(sizes)}>{children}</Box>
);
